<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading', 'auth'],
  data() {
    return {
      loading: true,
      tableColumns: [
        { key: 'name', label: 'Name' },
        { key: 'description', label: 'Description' },
        { key: 'created_at', label: 'Created' },
        { key: 'actions', label: 'Actions', width: '80px' },
      ],
      positions: [],
      search: '',
      pagination: {
        current_page: 1,
        per_page: 50,
        last_page: 1,
        total: 0,
        links: [],
      },
    };
  },
  mounted() {
    this.fetchPositions();
  },
  methods: {
    async fetchPositions(page = 1) {
      this.loading = true;
      try {
        const response = await axios.get('/hrms/positions', {
          params: {
            page,
            search: this.search || undefined,
          },
        });
        this.positions = response.data.data.data;
        this.pagination = {
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page,
          last_page: response.data.data.last_page,
          total: response.data.data.total,
          links: response.data.data.links,
        };
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      this.fetchPositions(1);
    },

    openAdd() {
    this.$refs.posModal.add();
    this.$openModal('hrm_position_modal');
    },

    openEdit(pos) {
    this.$refs.posModal.edit(pos);
    this.$openModal('hrm_position_modal');
    },

    confirmDelete(pos) {
    this.$refs.posModal.setDelete(pos);
    this.$openModal('hrm_position_delete_modal');
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Header -->
      <div class="d-md-flex d-flex align-items-center justify-content-between page-breadcrumb mb-3">
        <div>
          <h4 class="page-title mb-0">Positions</h4>
        </div>
        <div class="d-flex align-items-center flex-wrap gap-2">
          <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" @click="openAdd">
            <i class="ti ti-circle-plus me-2"></i>Add Position
          </a>
        </div>
      </div>

      <!-- Main Card -->
      <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">

        <!-- Card Header -->
        <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
          <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
            Position List
            <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
          </h5>

          <!-- Search -->
          <div class="d-flex align-items-center gap-2">
            <div class="l-search-wrap">
              <input type="text" class="l-search-input" v-model="search" placeholder="Search positions..." @keyup.enter="onSearch" />
              <span style="padding:0 10px; color:#94a3b8;"><i class="ti ti-search"></i></span>
            </div>
          </div>
        </div>

        <!-- Card Body — Table -->
        <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">

          <app-table
            :columns="tableColumns"
            :rows="positions"
            :pagination="pagination"
            :loading="loading"
            empty-text="No positions found."
            empty-icon="ti ti-briefcase"
            @page-change="fetchPositions"
          >
            <!-- Description -->
            <template #description="{ row }">
              {{ row.description || '-' }}
            </template>

            <!-- Created -->
            <template #created_at="{ row }">
              <span style="font-size:11.5px; color:#94a3b8;">{{ $formatDate(row.created_at) }}</span>
            </template>

            <!-- Actions -->
            <template #actions="{ row }">
              <div class="dropdown">
                <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown">
                  <i class="ti ti-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openEdit(row)">
                      <i class="ti ti-edit me-1"></i>Edit
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" @click="confirmDelete(row)">
                      <i class="ti ti-trash me-1"></i>Delete
                    </a>
                  </li>
                </ul>
              </div>
            </template>
          </app-table>

        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <hrm-position-modal ref="posModal" @updated="fetchPositions" />
</template>

<style scoped>
.l-search-wrap {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.l-search-wrap:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .1);
}

.l-search-input {
  border: none;
  outline: none;
  height: 34px;
  padding: 0 10px;
  font-size: 12.5px;
  color: #1e293b;
  width: 200px;
  background: transparent;
}
</style>